import { Alert, AlertTitle, Box, IconButton } from '@mui/material';
import React from 'react'
import DeleteIcon from '@mui/icons-material/Delete';
const TableSubHeander = ({ lableForDelete,deletedItem,handleBulkDelete}) => {
    return (
            <Box sx={{ width: '100%' }} >

                <Alert severity="warning"
                    action={
                        <IconButton
                            aria-label="close"
                            size="small"
                            onClick={handleBulkDelete}
                        >
                            <DeleteIcon sx={{color:'red'}}  />
                        </IconButton>
                    }

                >
                   {`${deletedItem} Item Selected: Are you sure you want to delete this ${lableForDelete} ?`}
                </Alert>


            </Box>
    

    );

}

export default TableSubHeander